export enum IndustryTypeEnum {
  AUTRES = 'Autres',
  BANQUE = 'Banque',
  EXPERTS_COMPTABLE = 'Experts comptable',
  FORMATION = 'Formation',
  NOTAIRE = 'Notaire',
  PHARMACIE = 'Pharmacie',
  IMMOBILIER = 'Immobilier',
  POMPES_FUNERAIRES = 'Pompes funèbres',
}
